import CardLinkList from './CardLinkList'

export default CardLinkList
